export default "__VITE_ASSET__rC2q0lL7__"